import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { VideoCallsActions } from '../../../video-conference/store/actions/videoCall';
import { UISocketDataMessage } from '../../models/UISocket';
import { VideoCallEventBase } from '../../models/VideoCallEventBase';
import { AppState } from '../../store/app-state';
import { SocketAction, SocketActionHandler } from '../SocketActionHandler';

export interface UISocketJoinedParticipantVideoCallEventMessage extends UISocketDataMessage, VideoCallEventBase {
    callId: string;
    userName: string;
    sessionId: string;
    url: string;
    ownerToken: string;
    isOwner: boolean;
}

@Injectable()
export class VideoCallJoinedParticipantHandler implements SocketActionHandler {
    readonly action: SocketAction = 'joinedParticipant';

    constructor(private store: Store<AppState>) {}

    handle(event: UISocketJoinedParticipantVideoCallEventMessage): void {
        this.store.dispatch(
            VideoCallsActions.videoCallParticipantJoined({
                siteId: event.siteId,
                url: event.url,
                ownerToken: event.ownerToken,
                userName: event.userName,
                isOwner: event.isOwner,
            }),
        );
    }
}
